export default "__VITE_ASSET__L$V4B3of__"